export const getSoleAvailableContentType = (contentTypes: string[] | undefined): string | undefined => {
  if (contentTypes?.length !== 1) {
    return undefined;
  }

  return contentTypes[0];
};

export const shouldShowFileUploadTop = (contentType: any): boolean => {
  return contentType?.usesFilesProcessor === true && contentType != null;
};

export const shouldShowFileUploadBottom = (contentType: any): boolean => {
  return contentType?.usesFilesProcessor !== true && contentType != null;
};

export const shouldShowFileMetadataTable = (needsToRenderFilesInTable: boolean, fileCount: number): boolean => {
  return needsToRenderFilesInTable && fileCount > 0;
};
